// src/app/features/conversations/FloatingChat/FloatingChat.tsx

import React from 'react';
import { useFloatingChat } from './FloatingChatProvider';
import FloatingChatButton from './FloatingChatButton';
import FloatingChatPanel from './FloatingChatPanel';

// 1) Import your Auth hook
import { useAuth } from 'utils/AuthProvider';

export default function FloatingChat() {
  const { isOpen, openChat, closeChat } = useFloatingChat();
  const { isAuthenticated } = useAuth(); // <--- check if user is logged in

  // If SSR or no window, skip
  if (typeof window === 'undefined') return null;

  // 2) If user is NOT authenticated, hide everything
  if (!isAuthenticated) {
    return null; // no button, no panel
  }

  // If user is authenticated, show the floating chat
  const toggleChat = () => {
    isOpen ? closeChat() : openChat();
  };

  return (
    <>
      <FloatingChatButton isOpen={isOpen} onClick={toggleChat} />
      <FloatingChatPanel isOpen={isOpen} />
    </>
  );
}
